import { app } from '../../../app.module'
/**
 * メモ管理モーダル
 * @class MemoManagementModalComponentCtrl
 */
class MemoManagementModalComponentCtrl {
  constructor(
    $scope,
    private $mdDialog: {
      hide: Function
    }
  ) {}

  /**
   * モーダルを閉じる処理
   */
  public close(): void {
    this.$mdDialog.hide()
  }
}

app.component('memoManagementModal', {
  bindings: {
    objectType: '@',
    objectId: '@',
    snsType: '@',
    onChange: '&',
  },
  template: require('./memo-management-modal.pug')(),
  controller: MemoManagementModalComponentCtrl,
})
